<template>
  <div class="payment-page style2">
    <div class="back-to-home">
      <router-link :to="{ name: 'loanSummary' }" >
        <img src="@/assets/img/left-arrow.svg" alt="Back home" />
        <img src="@/assets/img/left-arrow-red.svg" alt="Back home" />
        <span>Trở về</span>
      </router-link>
    </div>
    <div class="contract-detail">
      <div
        class="flex flex-col-reverse xl:flex-row items-center"
      >
        <div class="w-full lg:w-full xl:w-2/5">
          <div class="contract-detail-title">
          <span><img src="@/assets/img/demo11.svg" alt="demo"/></span>
          <span>Thông tin chi tiết hợp đồng</span>
          </div>
          <p class="contract-number">
            HỢP ĐỒNG SỐ {{contract.ContractNo}}
          </p>
          <hr />
          <div class="payment-detail-wrap">
            <p>CHI TIẾT SỐ TIỀN THANH TOÁN:</p>
            <ul class="payment-detail">
              <li>
                <div
                  class="flex justify-between"
                >
                  <p>Gốc:</p>
                  <p>{{Number(contract.Origin).toLocaleString()}} VND</p>
                </div>
              </li>
              <li>
                <div
                  class="flex justify-between"
                >
                  <p>Lãi:</p>
                  <p>{{Number(contract.InterestRate).toLocaleString()}} VND</p>
                </div>
              </li>
              <li>
                <div
                  class="flex justify-between"
                >
                  <p>Phạt trễ hạn:</p>
                  <p
                    class="highlight-color"
                  >
                    {{Number(contract.LateFee).toLocaleString()}} VND
                  </p>
                </div>
              </li>
              <li>
                <div
                  class="flex justify-between"
                >
                  <p>Tiền dư:</p>
                  <p>
                    {{Number(contract.ResidualAmount).toLocaleString()}} VND
                  </p>
                </div>
              </li>
              <li>
                <div
                  class="flex justify-between"
                >
                  <p>Số ngày trễ hạn:</p>
                  <p style="color: red">
                    {{contract.NumDayOverdue}}
                  </p>
                </div>
              </li>
            </ul>
            <hr />
            <div
              class="flex justify-between flex-col md:flex-col lg:flex-row"
            >
              <div
                class="mb-4 md:mb-4 lg:mb-0"
              >
                <p>
                  NGÀY ĐẾN HẠN THANH TOÁN:
                </p>
                <p
                  class="payment-history highlight-color"
                  v-if="contract.PaymentDueDate && contract.PaymentDueDate !== null"
                >
                  {{ contract.PaymentDueDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
                </p>
                <p class="payment-history highlight-color" v-else></p>
              </div>
              <div>
                <p>
                  SỐ TIỀN CẦN THANH TOÁN:
                </p>
                <p
                  class="payment-history highlight-color text-left lg:text-right"
                >
                  {{Number(contract.TotalPaymentAmount).toLocaleString()}} VND
                </p>
              </div>
            </div>
          </div>
          <button v-if="isConfirmed === false" class="contract-button"  @click="isShownModal = true" >
            thanh toán ngay {{Number(contract.TotalPaymentAmount).toLocaleString()}}
          </button>
          <router-link  v-else class="contract-button" tag="button" :to="{ name: 'paymentDetail', params: { contractNo: contractNo } }">
            thanh toán ngay {{Number(contract.TotalPaymentAmount).toLocaleString()}}
          </router-link>
          <hr />
          <div
            class="flex justify-between flex-col md:flex-col lg:flex-row"
          >
            <div class="mb-4 md:mb-4 lg:mb-0">
              <p>
                NGÀY THANH TOÁN GẦN NHẤT:
              </p>
              <p class="payment-history" v-if="contract.NearestPaymentDate && contract.NearestPaymentDate !== null">
                {{ contract.NearestPaymentDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
              </p>
              <p class="payment-history" v-else>
              </p>
            </div>
            <div class="">
              <p>SỐ TIỀN ĐÃ THANH TOÁN:</p>
              <p
                class="text-left payment-history lg:text-right"
              >
                {{Number(contract.NearestPaymentAmount).toLocaleString()}}
              </p>
            </div>
          </div>
        </div>
        <div
          class="w-full lg:full xl:w-3/5 text-center"
        >
          <div class="contract-product">
            <img v-if="contract.Car" :src="`data:image/jpeg;base64,${contract.Car.Image}`" />
            <!--<p class="product-name">
              {{contract.Car.CarTypeName}}
            </p>-->
            <div v-if="contract.Car" class="car-number">
              {{contract.Car.PlateNo}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="payment-schedule">
      <TabCard :tabs="tabs" :initialTab="initialTab">
        <template slot="tab-head-paymentSchedule">
          Kế hoạch thanh toán
        </template>
        <template slot="tab-panel-paymentSchedule">
          <payment-schedule :contract-no="contractNo"/>
        </template>

        <template slot="tab-head-paymentHistory">
          Lịch sử thanh toán
        </template>
        <template slot="tab-panel-paymentHistory">
          <payment-history :contract-no="contractNo"/>
        </template>

        <template slot="tab-head-carInsurance">
          Bảo hiểm xe
        </template>
        <template slot="tab-panel-carInsurance">
          <car-insurance :contract-no="contractNo"/>
        </template>

        <template slot="tab-head-carRegistrationStatus">
          Tình trạng đăng ký xe
        </template>
        <template slot="tab-panel-carRegistrationStatus">
          <car-registration-status :contract-no="contractNo"/>
        </template>

      </TabCard>
    </div>
    <UiModal closeOnOverlay :show.sync="isShownModal">
      <div class="modal-container modal-scroll bg-white w-11/12 md:max-w-md mx-auto shadow-lg z-50 overflow-y-auto">
        <div class="modal-content text-left">
          <!--Title-->
          <div class="modal-header bg-danger text-white">
            <p class="modal-title">
              THÔNG BÁO
            </p>
          </div>
          <!--Body-->
          <div class="modal-content">
            <div class="modal-body payment-terms">
              <p><center><b>Điều khoản sử dụng dịch vụ thanh toán trực tuyến</b></center></p>
              <br>
              <p>Khách hàng cam kết:</p>
              <ol>
                <li>
                  Việc sử dụng dịch vụ thanh toán trực tuyến là hoàn toàn tự nguyện và khách hàng không thể hủy, thay đổi bất kỳ giao dịch thanh toán nào đã được thực hiện thành công.
                </li>
                <li>
                  Đảm bảo tính chính xác của thông tin thẻ (Tên chủ thẻ, số thẻ, thời hạn thẻ), thông tin tài khoản ngân hàng và thông tin thanh toán khi thực hiện giao dịch thanh toán trực tuyến.
                </li>
                <li>
                  Chịu trách nhiệm bảo mật thông tin đăng nhập tài khoản thanh toán trực tuyến, các thông tin thẻ, thông tin tài khoản ngân hàng, mã OTP (được cung cấp qua điện thoại) và chịu toàn bộ thiệt hại xảy ra do vô tình hay cố ý để bất kỳ cá nhân, tổ chức nào sử dụng thông tin đăng nhập tài khoản thanh toán trực tuyến , các thông tin thẻ, thông tin tài khoản ngân hàng, mã OTP nhằm thực hiện các hành vi gian lận trong dịch vụ thanh toán trực tuyến.
                </li>
              </ol>
              <p>Mọi chi tiết liên quan đến các giao dịch thanh toán trực tuyến sẽ được bảo mật theo quy định của pháp luật.</p>

            </div>
          </div>
          <!--Footer-->
          <div class="modal-footer">
            <div class="hd-modal-footer__wrapper">
              <div class="hd-modal-footer__left">
                <input
                  id="agree"
                  v-model="agree"
                  type="checkbox"
                  style="margin-right: 5px;"
                />
                <label for="agree">Tôi đã đọc và đồng ý với mọi điều khoản thanh toán.</label>
              </div>
              <div class="hd-modal-footer__right">
                <button class="hd-modal-footer__button" @click="isShownModal = false">
                  QUAY LẠI
                </button>
                <button class="hd-modal-footer__button" @click="submitModalHandler" :disabled="agree === false">
                  TIẾP TỤC
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UiModal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TabCard from '@/components/TabCard'
import PaymentSchedule from './includes/PaymentSchedule.vue'
import PaymentHistory from './includes/PaymentHistory.vue'
import CarInsurance from './includes/CarInsurance.vue'
import CarRegistrationStatus from './includes/CarRegistrationStatus.vue'
import { PaymentSummaryService } from '@/services/paymentSummary.service'
import UiModal from '@/components/UiModal.vue'

export default {
  name: 'LoanDetail',
  components: {
    TabCard,
    PaymentSchedule,
    PaymentHistory,
    CarInsurance,
    CarRegistrationStatus,
    UiModal
  },
  props: {
  },
  computed: {
    ...mapState('contract', {
      contract: 'currentContract'
    })
  },
  data () {
    return {
      isShownModal: false,
      isConfirmed: false,
      agree: false,
      contractNo: this.$route.params.contractNo,
      initialTab: 'paymentSchedule',
      tabs: [
        'paymentSchedule',
        'paymentHistory', 'carInsurance', 'carRegistrationStatus']
    }
  },
  methods: {
    fetchData () {
      this.$store.dispatch('contract/getCurrent', this.contractNo).then(result => {
        if (result.Car && result.Car.BrandLogo !== '') {
          this.$bus.$emit('changeBrandLogo', result.Car.BrandLogo)
        }
      })
    },
    submitModalHandler () {
      PaymentSummaryService.updateGetConfirmedTermsOfPayment().then(response => {
        if (response.data.data.IsResult === true) {
          this.$router.push({ name: 'paymentDetail', params: { contractNo: this.contractNo } })
        }
      })
    }
  },
  created () {
    this.fetchData()
    PaymentSummaryService.getConfirmedTermsOfPayment().then(response => {
      if (response.data.data.IsResult === false) {
        this.isConfirmed = true
      }
    })
  },
  destroyed () {
    this.$bus.$emit('changeBrandLogo')
  }
}
</script>
<style lang="scss">
  .payment-terms ol {
  list-style: revert;
  margin-left: 20px;
  }
  .hd-modal-footer {
  &__wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  }
  &__right {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 5px;
  margin-bottom: 5px;
  }
  &__button {
  background: #eb0a1e;
  color: #fff;
  display: block;
  padding: 16px;
  text-decoration: none;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.14);
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 1.25px;
  border-radius: 4px;
  min-width: 120px;
  & + .hd-modal-footer__button {
  margin-left: 10px;
  }

  &:disabled {
  opacity: 0.35;
  }
  }
  }
</style>
